/*
 *
 * EkycPage constants
 *
 */

// Form
export const CHANGE_AADHAAR_NUMBER = 'CHANGE_AADHAAR_NUMBER';
export const CHANGE_OTP_CODE = 'CHANGE_OTP_CODE';
export const ADD_FORM_FIELD_ERROR = 'ADD_FORM_FIELD_ERROR';
export const TOGGLE_CONSENT = 'TOGGLE_CONSENT';

// Public Key
export const FETCH_PUBLIC_KEY_REQUEST = 'FETCH_PUBLIC_KEY_REQUEST';
export const FETCH_PUBLIC_KEY_SUCCESS = 'FETCH_PUBLIC_KEY_SUCCESS';
export const FETCH_PUBLIC_KEY_FAILURE = 'FETCH_PUBLIC_KEY_FAILURE';

// Generate OTP (was verify_captcha)
export const GENERATE_OTP_REQUEST = 'GENERATE_OTP_REQUEST';
export const GENERATE_OTP_SUCCESS = 'GENERATE_OTP_SUCCESS';
export const GENERATE_OTP_FAILURE = 'GENERATE_OTP_FAILURE';

// Verify OTP
export const VERIFY_OTP_REQUEST = 'VERIFY_OTP_REQUEST';
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_FAILURE = 'VERIFY_OTP_FAILURE';

// eKYC Status
export const EKYC_STATUS_REQUEST = 'EKYC_STATUS_REQUEST';
export const EKYC_STATUS_SUCCESS = 'EKYC_STATUS_SUCCESS';
export const EKYC_STATUS_FAILURE = 'EKYC_STATUS_FAILURE';

// Edit / Reset
export const EDIT_AADHAAR_NUMBER = 'EDIT_AADHAAR_NUMBER';
export const RESET_EKYC_FORM = 'RESET_EKYC_FORM';

// Redirect
export const REDIRECT_REQUEST = 'REDIRECT_REQUEST';

// VID Modal
export const HANDLE_VID_MODAL = 'HANDLE_VID_MODAL';

// KYC ID
export const UPDATE_KYC_ID = 'UPDATE_KYC_ID';
